/**
 * Biometric login is generally available — no gate. Function kept (always
 * returning true) so we don't have to delete every call site, and so a
 * future kill-switch can be reinstated cheaply if needed.
 *
 * Per-platform availability is still gated by the actual capability check
 * (WebAuthnBiometric.isAvailable / CapacitorBiometric.isAvailable), so
 * platforms without WebAuthn or Cap biometrics still silently skip the UI.
 */
export function isBiometricLoginEnabled() {
	return true;
}
